import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import CategoryDropdown from "./CategoryDropdown";
import LocationAutocomplete from "./LocationAutocomplete";
import CustomSelect from "./inputs/select";
import CustomMultiSelect from "./inputs/multiSelect";
import How from "./how";
import { fetchSearchResults, setSearchParams } from "../store/slices/searchSlice";

const SearchFull = ({ compact = false, isGoogleLoaded, onSubmit, category = false }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { query, categoryId, categoryName,filtre, location: reduxLocation, how: reduxHow, when: reduxWhen, lat: reduxLat, lng: reduxLng } = useSelector((state) => state.search);
  const [locationQuery, setLocationQuery] = useState(reduxLocation || "");
  const [how, setHow] = useState(reduxHow || []);
  const [when, setWhen] = useState(reduxWhen || "all_time");
  const [lat, setLat] = useState(reduxLat || null);
  const [lng, setLng] = useState(reduxLng || null);
  const [isMobile, setIsMobile] = useState(false);
  const handleLocationSelect = (place) => {
    if (!place) {
      setLocationQuery("");
      setLat(null);
      setLng(null);
      dispatch(setSearchParams({ location: "", lat: null, lng: null }));
    } else {
      setLocationQuery(place.description);
      dispatch(setSearchParams({ location: place.description }));
      if (isGoogleLoaded && window.google && window.google.maps) {
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ placeId: place.place_id }, (results, status) => {
          if (status === window.google.maps.GeocoderStatus.OK && results[0]) {
            const { lat: googleLat, lng: googleLng } = results[0].geometry.location;
            setLat(googleLat());
            setLng(googleLng());
            dispatch(setSearchParams({ lat: googleLat(), lng: googleLng() }));
          }
        });
      }
    }
  };
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize(); // Set initial value
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const handleLocationChange = (value) => {
    setLocationQuery(value);
    dispatch(setSearchParams({ location: value }));
    if (!value) {
      setLat(null);
      setLng(null);
      dispatch(setSearchParams({ lat: null, lng: null }));
    }
  };

  const handleCategoryChange = (searchData) => {
    dispatch(setSearchParams(searchData));
  };

  const handleSubmit = (e) => {
    
    e.preventDefault();

    const searchData = {
      categoryId: categoryId || null,
      filtre: filtre,
      query: query || "",
      categoryName: categoryName || "",
      location: locationQuery || reduxLocation || "",
      how: how.length > 0 ? how : reduxHow || [],
      when: when || reduxWhen || "all_time",
      lat: lat || reduxLat || null,
      lng: lng || reduxLng || null,
      sortBy: "relevance",
      
    };

    dispatch(setSearchParams(searchData));
    dispatch(fetchSearchResults(searchData));

    if (category) {
      navigate("/resultats", { replace: true });
    }

    if (onSubmit) {
      onSubmit(searchData);
    }
  };

  return (
    <div className={`container searchfull ${compact ? "searchfull-compact" : ""}`}>
      <form onSubmit={handleSubmit} className="searchfull-form">
       {compact && isMobile ? 
        <button
        type="submit"
        className={`btn ${compact ? "searchfull-cta-compact" : "searchfull-cta-primary"}`}
      >
        {compact ? <img src="/images/loop-compact.svg" alt="Search" /> : "Rechercher"}
      </button>
      : <>
      <div className="searchfull-group">
          {!compact && <label htmlFor="search-query">Que recherchez-vous ?</label>}
          <CategoryDropdown onChange={handleCategoryChange} />
        </div>
        <div className="searchfull-separator"></div>
        <div className="searchfull-group">
          {!compact && <label htmlFor="location-query">Où ?</label>}
          <LocationAutocomplete
            onLocationSelect={handleLocationSelect}
            isGoogleLoaded={isGoogleLoaded}
            value={locationQuery}
            onChange={handleLocationChange}
            deleted={true}
          />
        </div>
        <div className="searchfull-separator"></div>
        <div className="searchfull-group">
          {!compact && <label htmlFor="how-query">Comment ?</label>}
          <CustomMultiSelect
            options={[
              { label: "À domicile", value: "onsite" },
              { label: "En ligne", value: "enligne" },
              { label: "Chez le professionnel", value: "chezpro" },
            ]}
            placeholder="Sélectionnez l’option"
            onChange={(selectedValues) => setHow(selectedValues)}
            selectedValues={how}
          />
        </div>
        <div className="searchfull-separator"></div>
        <div className="searchfull-group">
          {!compact && <label htmlFor="when-query">Quand ?</label>}
          <CustomSelect
            options={[
              { label: "À tout moment", value: "all_time" },
              { label: "Aujourd'hui", value: "today" },
              { label: "Demain", value: "tomorrow" },
            ]}
            placeholder="Sélectionnez l’option"
            onChange={(value) => setWhen(value)}
            selectedValue={when}
          />
        </div>
        <button
          type="submit"
          className={`btn ${compact ? "searchfull-cta-compact" : "searchfull-cta-primary"}`}
        >
          {compact ? <img src="/images/loop-compact.svg" alt="Search" /> : "Rechercher"}
        </button>
          </>}
        
      </form>
      {how?.length > 0 && !compact && (
        <div className="mt-24">
          <How lieu_intervention={how} setHow={setHow} todelete={true} />
        </div>
      )}
    </div>
  );
};

export default SearchFull;